import React from 'react';
import { IndexRoute, Route, IndexRedirect } from 'react-router'

import {requireAuth} from './auth';

import IndexPage from './pages/Index';

import LoginPage from './pages/Login/LoginPage';

import DashboardPage from './pages/Dashboard/DashboardPage';
import UsersDashboard from './pages/Dashboard/UsersDashboard';
import CirclesDashboard from './pages/Dashboard/CirclesDashboard';
import SportunitiesDashboard from './pages/Dashboard/SportunitiesDashboard';
import SportsDashboard from './pages/Dashboard/SportsDashboard';

import SportPage from './pages/Sport/SportPage';
import SportsList from './pages/Sport/SportsList';
import AddSport from './pages/Sport/AddSport';
import EditSport from './pages/Sport/EditSport';

import SportunitiesPage from './pages/Sportunity/SportunitiesPage';
import SportunitiesList from './pages/Sportunity/SportunitiesList';
import EditSportunity from './pages/Sportunity/EditSportunity';

import CirclesPage from './pages/Circle/CirclesPage';
import CirclesList from './pages/Circle/CirclesList';
import EditCircle from './pages/Circle/EditCircle';

import UserPage from './pages/User/UserPage';
import UsersList from './pages/User/UsersList';
import EditUser from './pages/User/EditUser';

import ChatsPage from './pages/Chats/ChatsPage';
import ChatsList from './pages/Chats/ChatsList';
import EditChat from './pages/Chats/EditChat';

import VenuePage from './pages/Venue/VenuePage';
import VenueList from './pages/Venue/VenueList';
import EditVenue from './pages/Venue/EditVenue';

import LockersPage from './pages/Locker/LockersPage';

import SportsQueries from './queries/SportsQueries';
import SportListQueries from './queries/SportListQueries';
import CirclesListQueries from './queries/CirclesListQueries';
import SportunitiesListQueries from './queries/SportunitiesListQueries';
import UsersListQueries from './queries/UsersListQueries';


const ViewerQueries = {
  viewer: () => Relay.QL`query { viewer }`,
};

export default (
  <Route
    path="/">

    <IndexRedirect from="/" to="/dashboard"/>

    <Route
      path="/login"
      component={LoginPage}
    />

    <Route
      path=""
      component={IndexPage}
      onEnter={requireAuth}>

      <Route
        path="dashboard"
        component={DashboardPage}
        >

        <Route
          path="users"
          component={UsersDashboard}
          queries={SportsQueries}
        />
        <Route
          path="sportunities"
          component={SportunitiesDashboard}
          queries={SportsQueries}
        />
        <Route
          path="circles"
          component={CirclesDashboard}
          queries={SportsQueries}
        />
        <Route
          path="sports"
          component={SportsDashboard}
          queries={SportsQueries}
        />

      </Route>

      <Route
        path="sports"
        component={SportPage}
        queries={SportsQueries}>

        <Route
          path="list"
          component={SportsList}
          queries={SportListQueries}
            />

        <Route
          path="add"
          component={AddSport}
          queries={SportListQueries}
        />

        <Route
          path="edit/:sportId"
          component={EditSport}
          queries={ViewerQueries}
        />

      </Route>

      <Route
        path="sportunities"
        component={SportunitiesPage}
        queries={SportunitiesListQueries}
        >

        <Route path="list">

          <Route
            path="*"
            component={SportunitiesList}
            queries={SportunitiesListQueries}
          />

        </Route>

        <Route
          path="edit/:id"
          component={EditSportunity}
          queries={SportunitiesListQueries}
        />

      </Route>

      <Route
        path="circles"
        component={CirclesPage}
        queries={CirclesListQueries}
        >

        <Route path="list">

          <Route
            path="*"
            component={CirclesList}
            queries={CirclesListQueries}
          />

        </Route>

        <Route
          path="edit/:id"
          component={EditCircle}
          queries={CirclesListQueries}
        />

      </Route>

      <Route
        path="users"
        component={UserPage}
        queries={ViewerQueries}
      >

        <Route
          path="list">

          <Route
            path="*"
            component={UsersList}
            queries={ViewerQueries}
          />

        </Route>

        <Route
          path="edit"
          component={EditUser}
          queries={UsersListQueries}
        />

      </Route>
      <Route
        path="chats"
        component={ChatsPage}
        queries={ViewerQueries}
      >

        <Route
          path="list">

          <Route
            path="*"
            component={ChatsList}
            queries={ViewerQueries}
          />

        </Route>

        <Route
          path="edit/:chatId"
          component={EditChat}
          queries={ViewerQueries}
        />
      </Route>
      <Route
        path="venues"
        component={VenuePage}
        queries={ViewerQueries}
      >
        <Route path="list">
          <Route
            path="*"
            component={VenueList}
            queries={ViewerQueries}
          />
        </Route>
        <Route
          path="edit/:venueId"
          component={EditVenue}
          queries={ViewerQueries}
        />
      </Route>
      <Route
        path="lockers"
        component={LockersPage}
        queries={ViewerQueries}
      />

    </Route>

  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js